import { CommonModule } from '@angular/common';
import {
  ErrorHandler,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { AppContext, Logger } from '../../../common/public-api';
import { DefinedErrorCode } from './defined-error-code.const';
import { ErrorService } from './error.service';

import { GlobalErrorHandler } from '../../../core/error/global-error-handler';
import { APIM_FILTERS, DEFINED_BUSINESS_ERROR_CODE_TYPE } from './variables';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    Logger,
    AppContext,
    ErrorService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },

    {
      provide: DEFINED_BUSINESS_ERROR_CODE_TYPE,
      useValue: DefinedErrorCode,
    },
  ],
})
export class SIGVErrorModule {
  constructor(@Optional() @SkipSelf() parentModule: SIGVErrorModule) {
    if (parentModule) {
      throw new Error(
        `${
          new.target.name
        } is already loaded. Import in your base AppModule only.`
      );
    }
  }

  static forRoot(apimFilters: string[]): ModuleWithProviders<SIGVErrorModule> {
    return {
      ngModule: SIGVErrorModule,
      providers: [
        {
          provide: APIM_FILTERS,
          useValue: apimFilters,
        },
      ],
    };
  }
}
